import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddEditDataAgent from './AddEditDataAgent';
import DataAgentSourceTab from './dataAgentPopUp/DataAgentSourceTab';
import DataAgentExampleQueriesTab from './dataAgentPopUp/DataAgentExampleQueries/DataAgentExampleQueriesTab';

interface DataAgentTabsProps {
  entityType: string;
  dataAgentId?: string | null;
}

const DataAgentTabs: React.FC<DataAgentTabsProps> = ({ entityType, dataAgentId }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Dynamic tab labels based on entityType
  const getTabLabels = () => {
    if (entityType === 'edit') {
      return {
        // firstTab: t('dataAgents.tabs.editDataAgent'),
        firstTab: 'Edit Data Agent',
        // secondTab: t('dataAgents.tabs.dataAgentSources'),
        secondTab: 'Sources',
        // thirdTab: t('dataAgents.tabs.dataAgentExample'),

        thirdTab: 'Example',
      };
    } else {
      return {
        firstTab: t('dataAgents.tabs.addDataAgent'),
        secondTab: t('dataAgents.tabs.dataAgentSources'),
        thirdTab: t('dataAgents.tabs.dataAgentExample'),
      };
    }
  };

  const tabLabels = getTabLabels();

  // Show all three tabs only in EDIT mode
  const showSourcesTab = entityType === 'edit';
  const showExampleTab = entityType === 'edit';

  return (
    <Box sx={{ p: 3 }}>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="data agent form tabs"
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              ...(entityType === 'add' && {
                width: '100%',
                maxWidth: '100%',
              }),
            },
          }}
        >
          <Tab label={tabLabels.firstTab} />
          {showSourcesTab && <Tab label={tabLabels.secondTab} />}
          {showExampleTab && <Tab label={tabLabels.thirdTab} />}
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box>
        {/* First Tab - Add/Edit Data Agent Form */}
        {activeTab === 0 && (
          <Box>
            <AddEditDataAgent />
          </Box>
        )}

        {/* Second Tab - Data Agent Sources */}
        {activeTab === 1 && showSourcesTab && (
          <Box>
            <DataAgentSourceTab dataAgentId={dataAgentId || ''} />
          </Box>
        )}

        {/* Third Tab - Data Agent Example */}
        {activeTab === 2 && showExampleTab && (
          <Box sx={{ height: '100%' }}>
            <DataAgentExampleQueriesTab dataAgentId={dataAgentId || ''} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DataAgentTabs;
